module.exports = __webpack_public_path__ + "img/me.a38c1384.svg";